import { Box, Grid, Typography } from "@mui/material"
import {
  ACCUMULATION_TEM_WEBSITE,
  HOTLINE,
  INTRODUCE_STEPS_DESCRIPTION,
  TIME_TO_RECEIVE_VOTE,
} from "./ultils"
import WrapContainer from "./WrapContainer"
import { VerifyTick } from "src/shared"

const IntroduceAndNote = () => {
  return (
    <WrapContainer imgSrc="/assets/images/introduce.png" imgAlt="introduce">
      <Box
        justifyContent="flex-start"
        alignItems="flex-start"
        display="flex"
        rowGap={3}
        fontFamily="Roboto Slab"
        columnGap={1}
        sx={theme => ({
          [theme.breakpoints.down(600)]: {
            fontSize: 14,
            lineHeight: "18px",
          },
        })}
      >
        <Box flexWrap="nowrap" flex="0 0 auto" color="#1FA009" fontWeight={700}>
          Bước 1:
        </Box>
        <Box
          sx={{
            fontWeight: 400,
            color: "#999999",
          }}
        >
          Quý khách đăng nhập vào website:{" "}
          <span
            style={{
              color: "#1FA009",
              fontWeight: 700,
            }}
          >
            {ACCUMULATION_TEM_WEBSITE}
          </span>{" "}
          Hoặc quét qr để kiểm tra số lượng tích tem và đổi quà.
        </Box>
      </Box>
      {Object.keys(INTRODUCE_STEPS_DESCRIPTION).map((key: string) => (
        <Box
          justifyContent="flex-start"
          alignItems="flex-start"
          display="flex"
          rowGap={3}
          fontFamily="Roboto Slab"
          key={key}
          fontSize={16}
          columnGap={1}
          lineHeight="21px"
          sx={theme => ({
            [theme.breakpoints.down(600)]: {
              fontSize: 14,
              lineHeight: "18px",
            },
          })}
        >
          <Box
            flexWrap="nowrap"
            flex="0 0 auto"
            color="#1FA009"
            fontWeight={700}
          >{`Bước ${key}: `}</Box>
          <Box
            sx={{
              fontWeight: 400,
              color: "#999999",
            }}
          >
            {
              INTRODUCE_STEPS_DESCRIPTION[
                parseInt(key) as keyof typeof INTRODUCE_STEPS_DESCRIPTION
              ]
            }
          </Box>
        </Box>
      ))}
      <Grid mt={1} container justifyContent="center" rowGap={3}>
        <Typography
          fontSize={24}
          lineHeight={"31.65px"}
          color="#1FA009"
          fontWeight={700}
          fontFamily="Roboto Slab"
          sx={theme => ({
            [theme.breakpoints.down(600)]: {
              fontSize: 20,
              lineHeight: "26.4px",
            },
          })}
        >
          Lưu ý đổi quà tặng là phiếu mua hàng/ voucher
        </Typography>
        <Grid container flexWrap="nowrap" columnGap={2}>
          <Grid item>
            <VerifyTick />
          </Grid>
          <Grid item>
            <Typography
              fontSize={16}
              lineHeight="21px"
              fontWeight={400}
              fontFamily="Roboto Slab"
              color="#999999"
              sx={theme => ({
                [theme.breakpoints.down(600)]: {
                  fontSize: 14,
                  lineHeight: "18px",
                },
              })}
            >
              Quý khách sẽ nhận thông tin mã voucher/ phiếu mua hàng qua tin
              nhắn điện thoại. Thời gian nhận phiếu sẽ mất khoảng{" "}
              <span
                style={{
                  color: "#1FA009",
                  fontWeight: 700,
                }}
              >
                {TIME_TO_RECEIVE_VOTE}
              </span>{" "}
              ngày kể từ lúc đổi.
            </Typography>
          </Grid>
        </Grid>
        <Grid container flexWrap="nowrap" columnGap={2}>
          <Grid item>
            <VerifyTick />
          </Grid>
          <Grid item>
            <Typography
              fontSize={16}
              lineHeight="21px"
              fontWeight={400}
              fontFamily="Roboto Slab"
              color="#999999"
              sx={theme => ({
                [theme.breakpoints.down(600)]: {
                  fontSize: 14,
                  lineHeight: "18px",
                },
              })}
            >
              Trong trượng hợp khách hàng không nhận được tin nhắn vui lòng liên
              hệ Hotline{" "}
              <span
                style={{
                  color: "#1FA009",
                  fontWeight: 700,
                }}
              >
                {HOTLINE}
              </span>{" "}
              để được hỗ trợ.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </WrapContainer>
  )
}

export default IntroduceAndNote
